import Vue from 'vue';
import Vuex from 'vuex';
import { decodeJwtPayload } from '@/utils/jwt';

Vue.use(Vuex);

function parseUserFromToken() {
	try {
		const token = localStorage.getItem('token');
		if (!token) return null;
		const payload = decodeJwtPayload(token);
		if (payload.exp * 1000 < Date.now()) {
			localStorage.removeItem('token');
			return null;
		}
		return payload;
	} catch {
		return null;
	}
}

function parseVenueFromStorage() {
	try { return JSON.parse(localStorage.getItem('venue')) || null; }
	catch { return null; }
}

export default new Vuex.Store({
	state: {
		currentUser: parseUserFromToken(),
		currentVenue: parseVenueFromStorage(),
		venues: [],
	},
	getters: {
		currentUser:    (state) => state.currentUser,
		isAuthenticated:(state) => !!state.currentUser,
		userRole:       (state) => state.currentUser?.type || null,
		currentVenue:   (state) => state.currentVenue,
		venues:         (state) => state.venues,
		hasVenue:       (state) => !!state.currentVenue,
		currentVenueId: (state) => state.currentVenue?._id || null,
	},
	mutations: {
		SET_USER(state, payload) {
			state.currentUser = payload;
		},
		LOGOUT(state) {
			state.currentUser = null;
			state.currentVenue = null;
			state.venues = [];
			localStorage.removeItem('token');
			localStorage.removeItem('venue');
			localStorage.removeItem('venueId');
		},
		SET_VENUE(state, venue) {
			state.currentVenue = venue;
			if (venue) {
				localStorage.setItem('venueId', venue._id);
				localStorage.setItem('venue', JSON.stringify(venue));
			} else {
				localStorage.removeItem('venueId');
				localStorage.removeItem('venue');
			}
		},
		SET_VENUES(state, venues) {
			state.venues = venues;
		},
	},
	actions: {
		login({ commit }, token) {
			try {
				const payload = decodeJwtPayload(token);
				commit('SET_USER', payload);
			} catch {
				commit('SET_USER', null);
			}
		},
		logout({ commit }) {
			commit('LOGOUT');
		},
		selectVenue({ commit }, venue) {
			commit('SET_VENUE', venue);
		},
		setVenues({ commit }, venues) {
			commit('SET_VENUES', venues);
		},
	},
	modules: {},
});
